export default function RotatingSlogan({ item, fade }) {
    return (
        <section>
            <div className="slogan_part">
                <p
                    className={`position-absolute text-center small ${fade ? "fade-out" : "fade-in"
                        }`}>
                    <span>
                        <img src={item.icon} className="img_turner" alt="About Us" />
                        &nbsp;
                    </span>
                    {item.text}
                </p>
            </div>
        </section>
    );
}
